import React, { Component } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';

class TableUsing extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  columns = () => {
    const incubatorUuid = this.props.params.uuid;
    const config = [
      {
        title: '客户名称',
        dataIndex: 'custom',
        render: (text, record) => {
          return (
            <Link to={`/incubator/${incubatorUuid}/custom/detail/${record.customUuid}`}>
              {record.custom}
            </Link>
          );
        },
      },
      {
        title: '占用地址',
        dataIndex: 'addresses',
        render: (text, record) => {
          return (
            <div>
              {(text || []).map(item => {
                return (
                  <p key={item.uuid} style={{ marginBottom: '0' }}>
                    {item.name}
                  </p>
                );
              })}
            </div>
          );
        },
      },
      {
        title: '交易类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return <span>{record.settled.price ? '收费注册' : '免费注册'}</span>;
        },
      },
      {
        title: '开始时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          // 这里特殊，流程结束的时间是地址的开始时间
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '关联孵化器合同',
        dataIndex: 'settledUuid',
        key: 'settledUuid',
        render: (text, record) => {
          return (
            <Link to={`/incubator/contract/${record.settled.businessUuid}/info`}>
              {record.settled.isTransfer ? <span style={{ color: 'yellow' }}>转</span> : ''}
              {record.settled.no}
            </Link>
          );
        },
      },
      {
        title: '到期时间',
        dataIndex: 'deadline',
        key: 'deadline',
        render: (text, record) => {
          let day = 0;
          if (record.settled.deadline) {
            day = Math.floor((Date.now() - record.settled.deadline) / 86400000);
          }

          const element =
            day > 0 ? (
              <p style={{ color: 'red', marginBottom: '0' }}>（逾期{day}天）</p>
            ) : (
              <p style={{ marginBottom: '0' }}>（剩余{Math.abs(day)}天）</p>
            );
          return (
            <span>
              {record.settled.deadline
                ? moment.unix(record.settled.deadline / 1000).format('YYYY-MM-DD')
                : ''}
              {day ? element : ''}
            </span>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <div>
              {record.moveOutInstance ? (
                <div>迁出地址（申请中）</div>
              ) : (
                <div>
                  <Link to={`/incubator/oregistappMoveOut_manage/add/${record.uuid}`}>
                    迁出地址
                  </Link>
                </div>
              )}

              <Link to={`/incubator/oregistapp_manage/open/${record.uuid}`}>查看注册申请</Link>
            </div>
          );
        },
      },
    ];
    return config;
  };

  render() {
    const { data, pagination, isLoading } = this.props;
    return (
      <div>
        <Table
          onChange={this.handleChange}
          columns={this.columns()}
          pagination={pagination}
          loading={isLoading}
          dataSource={data}
          rowKey="uuid"
        />
      </div>
    );
  }
}

export default TableUsing;



// WEBPACK FOOTER //
// ./src/components/incubator/oregistapp/TableUsing.js